import { Size } from '@ocean/types/dist/appearance'
import { layouts, common } from '@ocean/ui'
import {
  DetailsHeaderLayout,
  DetailsHeaderSegment,
  DetailsBackgroundWrapper,
  DetailsInformationGridLayout,
} from 'layouts/details'
import { HeaderBackground, HeaderSidebar } from 'components/headers/common'

const { PageLayout, PageSegment, SectionLayout, SectionSpaceLayout, SectionSpaceSize } = layouts
const { Decorator, Spacer, skeletonStyles } = common
const { ContentTrace, Translucent } = skeletonStyles

const DetailsSkeleton: React.FC = () => (
  <PageLayout dataTest='DetailsSkeleton'>
    <PageSegment segmentId='content'>
      <Decorator root backgroundColor='white' textColor='black'>
        <DetailsHeaderLayout>
          <DetailsHeaderSegment segmentId='background'>
            <DetailsBackgroundWrapper>
              <HeaderBackground />
            </DetailsBackgroundWrapper>
          </DetailsHeaderSegment>

          <DetailsHeaderSegment segmentId='header'>
            <Translucent opacity='0.6'>
              <ContentTrace width='25%' color='greyLight' />
            </Translucent>
          </DetailsHeaderSegment>

          <DetailsHeaderSegment segmentId='title'>
            <Translucent opacity='0.6'>
              <ContentTrace width='90%' color='greyLight' size={Size.Large} />
              <br />
              <ContentTrace width='40%' color='greyLight' size={Size.Large} />
            </Translucent>
          </DetailsHeaderSegment>

          <DetailsHeaderSegment segmentId='sidebar'>
            <HeaderSidebar fill>
              <DetailsInformationGridLayout>
                <Translucent opacity='0.6'>
                  <ContentTrace width='35%' color='greyLight' size={Size.Small} />
                  <Spacer size='tiny' />
                  <ContentTrace width='60%' color='greyLight' />
                  <Spacer size='tiny' />
                </Translucent>
                <Translucent opacity='0.6'>
                  <ContentTrace width='50%' color='greyLight' size={Size.Small} />
                  <Spacer size='tiny' />
                  <ContentTrace width='85%' color='greyLight' />
                  <Spacer size='tiny' />
                </Translucent>
              </DetailsInformationGridLayout>
            </HeaderSidebar>
          </DetailsHeaderSegment>
        </DetailsHeaderLayout>
        <SectionSpaceLayout size={SectionSpaceSize.Base}>
          <SectionSpaceLayout size={SectionSpaceSize.Base}>
            <SectionLayout>
              <ContentTrace width='30%' color='greyLight' size={Size.Large} />
              <SectionSpaceLayout size={SectionSpaceSize.Base}>
                <ContentTrace width='75%' color='greyLight' />
                <br />
                <ContentTrace width='90%' color='greyLight' />
                <br />
                <ContentTrace width='50%' color='greyLight' />
              </SectionSpaceLayout>
            </SectionLayout>
          </SectionSpaceLayout>
        </SectionSpaceLayout>
      </Decorator>
    </PageSegment>
  </PageLayout>
)

export default DetailsSkeleton
